import { Box, Button, IconButton } from "@mui/material";
import TableRow from "@mui/material/TableRow";

import styled from "@emotion/styled";
import StickyTable from "../../components/table";
import Navbar from "../../components/navbar";
import { Cell } from "../../components/table/styles";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import { useModal } from "../../components/modal";
import { DeleteModal } from "../../components/appbar/modal";
import { smallButton } from "../../components/Button";
import AddModal from "./modal";
import MainFrame from "../../components/mainFrame";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import {
  useDeleteCourseMutation,
  useGetCoursesQuery,
} from "../../app/services/courses.api";
import { discountPercent } from "../../utils/discount";
import { apiErrorMessage } from "../../utils/apiError";
import toastError from "../../components/notif";
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo";
import { Course } from "../../types/course";
import { useState } from "react";

const Container = styled(Box)({
  padding: "1rem",
  width: "100%",
  height: "100%",
  minHeight: "90vh",
  maxHeight: "90vh",
});
function Courses() {
  const { setShow, setContent } = useModal();
  const [query, setQuery] = useState<{
    page?: number;
    size?: number;
    title?: string;
  }>({ page: 0, size: 10 });
  const { data, isLoading, isFetching } = useGetCoursesQuery(query);
  const navigate = useNavigate();
  const [deleteCourse] = useDeleteCourseMutation();
  function handleOpenModal(type: string, id?: string) {
    if (type === "edit" && id) {
      const course = data?.courses?.entities[id];
      setContent({
        title: " ویرایش دوره",
        body: <AddModal defaultValue={course} />,
      });
    }
    if (type === "add") {
      setContent({
        title: " افزودن دوره",
        body: <AddModal />,
      });
    }
    if (type === "delete" && id) {
      setContent({
        title: "حذف دوره",
        body: (
          <DeleteModal
            handleDelete={() =>
              deleteCourse(id)
                .unwrap()
                .then(() => setShow(false))
                .catch((err) => toastError(apiErrorMessage(err)))
            }
          />
        ),
      });
    }
    setShow(true);
  }
  return (
    <Container bgcolor="primary.light">
      <Helmet>
        <title> دوره ها | پنل ادمین yaadin</title>
      </Helmet>
      <Navbar title=" دوره ها">
        <Button
          onClick={() => handleOpenModal("add")}
          sx={[
            smallButton,
            {
              color: "divider",
              borderColor: "divider",
              borderStyle: "solid",
              borderWidth: "1px",
            },
          ]}
        >
          <AddIcon />
          افزودن دوره
        </Button>
      </Navbar>
      <StickyTable
        isLoading={isLoading || isFetching}
        headers={[
          { name: "عنوان" },
          { name: "تخفیف" },
          { name: "محدودیت دسترسی" },
          { name: "خصوصی سازمان" },
          { name: "توضیحات" },
          { name: "استاد" },
          { name: "کتاب معادل" },
        ]}
        operations={true}
        length={data?.length ?? 0}
        onPageQueryChange={(q) => setQuery((prev) => ({ ...prev, ...q }))}
      >
        {(data?.courses?.ids || []).map((id, indx) => {
          const course = data?.courses?.entities[id] as Course;
          return (
            <TableRow
              onClick={() => {
                navigate(`${course.slug}/snacks`, {
                  state: { courseId: id, title: course.title },
                });
              }}
              hover
              role="checkbox"
              tabIndex={-1}
              key={id}
              sx={{
                "&.MuiTableRow-root": {
                  cursor: "pointer",
                },
              }}
            >
              <Cell
                sx={{
                  "&.MuiTableCell-root": {
                    color: "divider",
                    fontSize: ".8rem",
                  },
                }}
              >
                {indx + 1}
              </Cell>
              <Cell>{course.title}</Cell>
              <Cell>{discountPercent(course.discount)}%</Cell>
              <Cell>{course.lock ? "yes" : "no"}</Cell>
              <Cell>{course.organPrivate ? "بله" : "خیر"}</Cell>
              <Cell>{course.desc}</Cell>
              <Cell>{course.teacher.userName}</Cell>
              <Cell>{course.books}</Cell>
              <Cell
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Button
                  size="small"
                  title="جلسه‌ها و ویدیوهای دوره"
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(`${course.slug}/snacks`, {
                      state: { courseId: id, title: course.title },
                    });
                  }}
                  sx={{ color: "divider", gap: ".25rem", whiteSpace: "nowrap" }}
                >
                  <OndemandVideoIcon sx={{ color: "divider" }} />
                  جلسات
                </Button>
                <IconButton
                  onClick={(e) => {
                    e.stopPropagation();
                    handleOpenModal("edit", course._id);
                  }}
                >
                  <EditIcon sx={{ color: "divider" }} />
                </IconButton>
                <IconButton
                  onClick={(e) => {
                    e.stopPropagation();
                    handleOpenModal("delete", course._id);
                  }}
                >
                  <DeleteIcon sx={{ color: "divider" }} />
                </IconButton>
              </Cell>
            </TableRow>
          );
        })}
      </StickyTable>
    </Container>
  );
}

export default MainFrame(Courses);
